import withWidth from '@material-ui/core/withWidth'
import clsx from 'clsx'
import MicRecorder from 'mic-recorder-to-mp3'
import { useCallback, useContext, useEffect, useRef, useState } from 'react'

import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  InputAdornment,
  List,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Popover,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import IconButton from '@material-ui/core/IconButton'
import InputBase from '@material-ui/core/InputBase'
import Paper from '@material-ui/core/Paper'
import ClearIcon from '@material-ui/icons/Clear'
import { isString } from 'lodash'

import { AuthContext } from '../../context/Auth/AuthContext'
import { EditMessageContext } from '../../context/EditingMessage/EditingMessageContext'
import { ReplyMessageContext } from '../../context/ReplyingMessage/ReplyingMessageContext'
import { BotReplyContext } from '../../context/BotReply/BotReplyContext'
import toastError from '../../errors/toastError'
import { useLocalStorage } from '../../hooks/useLocalStorage'
import api from '../../services/api'
import { getBackendURL } from '../../services/config'
import { i18n } from '../../translate/i18n'
import RecordingTimer from './RecordingTimer'
import { ButtonPrimary } from '../ButtonPrimary'

import useQuickMessages from '../../hooks/useQuickMessages'
import useSettings from '../../hooks/useSettings'

import {
  BotMessageSquare,
  Camera,
  CircleCheck,
  CircleStop,
  CircleUserRound,
  CircleX,
  Key,
  Mic,
  Paperclip,
  PlusIcon,
  SearchIcon,
  Send,
  ShieldBan,
  Signature,
  Smile,
  UserRoundArrowLeft,
  VideoIcon,
  Zap
} from 'lucide-react'
import Draggable from 'react-draggable'
import { generateColor } from '../../helpers/colorGenerator'
import { getInitials } from '../../helpers/getInitials'
import { ButtonSecondary } from '../ButtonSecondary'
import EmojiOptions from '../EmojiOptions'
import { InputFieldText } from '../InputFieldText'
import MarkdownWrapper from '../MarkdownWrapper'
import QuickMessageOptions from '../QuickMessagesDropdown'
import { UploadDropZone } from '../UploadDropZone'
import { useStyles } from './style'

import { ReactComponent as IconPix } from '../../assets/icone_pix.svg'
import AudioPlayer from '../AudioPlayer'
import { ButtonAddNew } from '../ButtonAddNew'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import TransferTicketModalCustom from '../TransferTicketModalCustom'


const normalizePixConfigs = configs => {
  if (!Array.isArray(configs)) return []

  return configs
    .map(config => ({
      type: config?.type || 'cpf',
      key: String(config?.key || '').trim(),
      accountName: String(config?.accountName || '').trim()
    }))
    .filter(config => config.key && config.accountName)
}

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
      bounds="parent"
    >
      <Paper {...props} style={{ ...props.style, margin: 0 }} />
    </Draggable>
  )
}

const IconSwitch = ({ children, ...props }) => {
  const { setter, value, tooltip } = props
  const classes = useStyles({ value })

  return (
    <Tooltip title={tooltip} placement="right" arrow>
      <IconButton
        onClick={() => setter(!value)}
        className={classes.actionsIconButton}
      >
        {children}
      </IconButton>
    </Tooltip>
  )
}

const ActionButtons = props => {
  const {
    inputMessage,
    loading,
    recording,
    audioUrl,
    handleSendMessage,
    handleCancelAudio,
    handleUploadAudio,
    handleStartRecording,
    handleStopToPreview,
    disableOption
  } = props
  const classes = useStyles()

  if (inputMessage) {
    return (
      <IconButton
        aria-label="sendMessage"
        component="span"
        onClick={handleSendMessage}
        disabled={disableOption}
        className={classes.sendMessageButton}
      >
        <Send className={classes.sendMessageIcons} />
      </IconButton>
    )
  } else if (audioUrl) {
    // MODO PREVIEW: Botão de Enviar o áudio gravado
    return (
      <IconButton
        aria-label="sendRecordedAudio"
        component="span"
        onClick={handleUploadAudio}
        disabled={loading}
        className={classes.sendMessageButton}
      >
        {loading ? (
          <CircularProgress size={24} />
        ) : (
          <Send className={classes.sendMessageIcons} />
        )}
      </IconButton>
    )
  } else if (recording) {
    return (
      <div className={classes.recorderWrapper}>
        <IconButton
          aria-label="cancelRecording"
          component="span"
          fontSize="large"
          // disabled={disableOption}
          onClick={handleCancelAudio}
        >
          <CircleX className={classes.cancelAudioIcon} />
        </IconButton>
        {loading ? (
          <div>
            <CircularProgress className={classes.audioLoading} />
          </div>
        ) : (
          <RecordingTimer />
        )}

        {/* <IconButton
          aria-label="sendRecordedAudio"
          component="span"
          onClick={handleUploadAudio}
          // disabled={disableOption}
        >
          <CircleCheck className={classes.sendAudioIcon} />
        </IconButton> */}
        <IconButton
          aria-label="stopRecording"
          component="span"
          onClick={handleStopToPreview}
        >
          <CircleStop className={classes.sendAudioIcon} />
        </IconButton>
      </div>
    )
  } else {
    return (
      <IconButton
        aria-label="showRecorder"
        component="span"
        disabled={disableOption}
        onClick={handleStartRecording}
        className={classes.sendMessageButton}
      >
        <Mic className={classes.sendMessageIcons} />
      </IconButton>
    )
  }
}

const CustomInput = props => {
  const {
    // loading,
    inputRef,
    ticketStatus,
    inputMessage,
    setInputMessage,
    handleSendMessage,
    handleInputPaste,
    disableOption,
    internalNote,
    onMenuClick,
    onCameraClick
  } = props
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const onKeyPress = e => {
    if (e.shiftKey) return
    else if (e.key === 'Enter') {
      e.preventDefault()
      handleSendMessage()
    }
  }

  const onPaste = e => {
    if (ticketStatus === 'open') {
      handleInputPaste(e)
    }
  }

  const renderPlaceholder = () => {
    if (ticketStatus !== 'open') {
      return i18n.t('messagesInput.placeholderClosed')
    }

    if (isMobile) {
      return i18n.t('messagesInput.placeholderOpen')
    }

    return (
      i18n.t('messagesInput.placeholderOpen') +
      ' ou digite / para mensagens rápidas'
    )
  }

  const setInputRef = input => {
    if (input) {
      inputRef.current = input
      inputRef.current.spellcheck = true
    }
  }

  const handleInputChange = e => {
    setInputMessage(e.target.value)
  }

  return (
    <div
      className={clsx(classes.messageInputWrapper, {
        [classes.messagePrivate]: internalNote
      })}
    >
      <InputBase
        autoFocus
        disabled={disableOption}
        inputRef={setInputRef}
        placeholder={renderPlaceholder()}
        multiline
        className={clsx(classes.messageInput, {
          [classes.messagePrivate]: internalNote
        })}
        maxRows={5}
        value={inputMessage}
        onChange={handleInputChange}
        onPaste={onPaste}
        onKeyPress={onKeyPress}
        id="messageInput"
        name="messageInput"
        startAdornment={
          isMobile && (
            <InputAdornment position="start">
              <IconButton
                onClick={onMenuClick}
                disabled={disableOption}
                size="small"
                className={classes.iconButtonMenu}
              >
                <PlusIcon size={24} />
              </IconButton>
            </InputAdornment>
          )
        }
        endAdornment={
          isMobile && (
            <InputAdornment position="end">
              {/* Ícone da Câmera */}
              <IconButton
                onClick={onCameraClick}
                disabled={disableOption}
                size="small"
                className={classes.iconButtonMenu}
              >
                <Camera size={24} />
              </IconButton>
            </InputAdornment>
          )
        }
      />
    </div>
  )
}

const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}

const MessageInputCustom = props => {
  const { ticket, showTabGroups, parentDrawerOpen, messagesListRef } = props
  const { status: ticketStatus, id: ticketId } = ticket
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const history = useHistory()

  // const [medias, setMedias] = useState([])
  const [inputMessage, setInputMessage] = useState('')
  const [showEmoji, setShowEmoji] = useState(false)
  const [showQuickMessages, setShowQuickMessages] = useState(false)
  const [quickMessages, setQuickMessages] = useState([])
  const [loading, setLoading] = useState(false)

  const [recording, setRecording] = useState(false)
  const [audioUrl, setAudioUrl] = useState(null)
  const [recordedBlob, setRecordedBlob] = useState(null)
  const mp3RecorderRef = useRef(null)

  const [, setPopupOpen] = useState(false)
  const [showContactPicker, setShowContactPicker] = useState(false) //
  const [showCamera, setShowCamera] = useState(false)
  const [showContactFilesOptions, setShowContactFilesOptions] = useState(false)
  const [showFilesList, setShowFilesList] = useState(false)
  const [isTypingSlash, setIsTypingSlash] = useState(false)
  const [joiningAttendance, setJoiningAttendance] = useState(false)
  const [joinedAttendance, setJoinedAttendance] = useState(false)

  const inputRef = useRef()
  const { setReplyingMessage, replyingMessage } =
    useContext(ReplyMessageContext)
  const { setEditingMessage, editingMessage } = useContext(EditMessageContext)
  const { user } = useContext(AuthContext)

  const signatureLabel = user?.name

  const [signMessage, setSignMessage] = useLocalStorage('signOption', true)
  const [internalNote, setInternalNote] = useLocalStorage('internalNote', false)

  const fileInputRef = useRef(null)

  const { list: listQuickMessages } = useQuickMessages()
  const { getAll: getAllSettings } = useSettings()
  const [showSignatureButtonSetting, setShowSignatureButtonSetting] =
    useState(true)
  const [companyPixConfigs, setCompanyPixConfigs] = useState([])
  const [showPixSelector, setShowPixSelector] = useState(false)
  const [botReplyStateLocal, setBotReplyStateLocal] = useState({
    open: false,
    position: null
  })
  const [botReplyValue, setBotReplyValue] = useState('')
  const botReplyContext = useContext(BotReplyContext)
  const botReplyState = botReplyContext
    ? botReplyContext.botReplyState
    : botReplyStateLocal
  const openBotReply = (position = null) => {
    if (botReplyContext) {
      botReplyContext.openBotReply(position)
    } else {
      setBotReplyStateLocal({ open: true, position })
    }
  }
  const closeBotReply = () => {
    if (botReplyContext) {
      botReplyContext.closeBotReply()
    } else {
      setBotReplyStateLocal(prev => ({ ...prev, open: false }))
    }
  }
  const showBotMenu = botReplyState.open
  const setShowBotMenu = open => (open ? openBotReply(null) : closeBotReply())

  const [anchorEl, setAnchorEl] = useState(null)
  const menuOpen = Boolean(anchorEl)

  const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false)
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false)
  const canShowManagementButtons = !showTabGroups || !ticket.isGroup

  const handleOpenTransferModal = e => {
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }
    setTransferTicketModalOpen(true)
  }

  const handleCloseTransferTicketModal = () => {
    setTransferTicketModalOpen(false)
  }

  const handleNewTicketModalClose = () => {
    setNewTicketModalOpen(false)
  }

  const handleUpdateTicketStatus = async (e, status, userId) => {
    setLoading(true)
    try {
      const updateData = {
        status: status,
        userId: userId || null
      }
      await api.put(`/tickets/${ticketId}`, updateData)
      setLoading(false)
      history.push(`/tickets/${ticketId}`)
    } catch (err) {
      setLoading(false)
      toastError(err)
    }
  }

  const handleOpenMenu = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleCloseMenu = () => {
    setAnchorEl(null)
  }

  // Helper para executar ação e fechar menu
  const executeAction = actionFn => {
    actionFn()
    handleCloseMenu()
  }

  const loadQuickMessages = useCallback(async () => {
    try {
      const messages = await listQuickMessages({ queueId: ticket?.queueId })

      const options = messages.map(m => {
        let truncatedMessage = m.message
        if (isString(truncatedMessage) && truncatedMessage.length > 35) {
          truncatedMessage = m.message.substring(0, 35) + '...'
        }
        return {
          value: m.message,
          label: `/${m.shortcode} - ${truncatedMessage}`,
          shortcode: m.shortcode,
          mediaPath: m.mediaPath || null,
          mediaName: m.mediaName || null
        }
      })
      setQuickMessages(options)
      return options
    } catch (error) {
      console.error('Erro ao carregar mensagens rápidas:', error)
      return []
    }
  }, [listQuickMessages, ticket?.queueId])

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const settings = await getAllSettings()
        const showSignatureButton = settings.find(
          s => s.key === 'showSignatureButton'
        )
        setShowSignatureButtonSetting(showSignatureButton?.value !== 'disabled')

        const companyPixKeysSetting = settings.find(
          s => s.key === 'companyPixKeys'
        )
        let parsedPixConfigs = []

        if (companyPixKeysSetting?.value) {
          try {
            parsedPixConfigs = normalizePixConfigs(
              JSON.parse(companyPixKeysSetting.value)
            )
          } catch (error) {
            parsedPixConfigs = []
          }
        }

        if (!parsedPixConfigs.length) {
          const companyPixKeyType =
            settings.find(s => s.key === 'companyPixKeyType')?.value || 'cpf'
          const companyPixKey =
            settings.find(s => s.key === 'companyPixKey')?.value || ''
          const companyPixAccountName =
            settings.find(s => s.key === 'companyPixAccountName')?.value || ''

          parsedPixConfigs = normalizePixConfigs([
            {
              type: companyPixKeyType,
              key: companyPixKey,
              accountName: companyPixAccountName
            }
          ])
        }

        setCompanyPixConfigs(parsedPixConfigs)

        // Se a configuração estiver desabilitada, força a assinatura sempre ativa
        if (showSignatureButton?.value === 'disabled') {
          setSignMessage(true)
        }
      } catch (error) {
        console.error('Error loading settings:', error)
      }
    }
    loadSettings()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (inputMessage === '/' || inputMessage.endsWith(' /')) {
      setIsTypingSlash(true)
      if (quickMessages.length === 0) {
        loadQuickMessages()
      }
      setShowQuickMessages(true)
    } else if (isTypingSlash && !inputMessage.includes('/')) {
      setIsTypingSlash(false)
      setShowQuickMessages(false)
    }
  }, [inputMessage, isTypingSlash, quickMessages.length])

  useEffect(() => {
    if (editingMessage) {
      if (
        signMessage &&
        editingMessage.body.startsWith(`*${signatureLabel}:*\n`)
      ) {
        setInputMessage(
          editingMessage.body.substr(editingMessage.body.indexOf('\n') + 1)
        )
      } else {
        setInputMessage(editingMessage.body)
      }
    }

    if (replyingMessage || editingMessage) {
      inputRef.current.focus()
    }
  }, [replyingMessage, editingMessage, signMessage, signatureLabel])

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
    setInternalNote(false)
    return () => {
      setShowEmoji(false)
      setShowQuickMessages(false)
      // setMedias([])
      setReplyingMessage(null)
      setEditingMessage(null)
      setInputMessage('')
      setAudioUrl(null)
      setRecordedBlob(null)
    }
  }, [ticketId])

  useEffect(() => {
    setJoinedAttendance(false)
    setJoiningAttendance(false)
  }, [ticketId])

  const handleSelectQuickMessage = async (quickMessage, shouldSend = false) => {
    let newMessage = inputMessage

    if (isTypingSlash) {
      const lastSlashIndex = inputMessage.lastIndexOf('/')
      newMessage =
        inputMessage.substring(0, lastSlashIndex) + quickMessage.value
    } else {
      newMessage = quickMessage.value
    }

    setInputMessage(newMessage)
    setShowQuickMessages(false)
    setIsTypingSlash(false)
    setPopupOpen(false)

    if (shouldSend) {
      // Se a configuração de botão de assinatura estiver desabilitada, força a assinatura
      const shouldSign = !showSignatureButtonSetting || signMessage

      const message = {
        read: 1,
        fromMe: true,
        mediaUrl: '',
        body: shouldSign
          ? `*${signatureLabel}:*\n${newMessage.trim()}`
          : newMessage.trim(),
        quotedMsg: replyingMessage
      }

      const url =
        editingMessage !== null
          ? `/messages/edit/${editingMessage.id}`
          : `/messages/${ticketId}`

      try {
        // Envia primeiro o texto da resposta rápida.
        await api.post(url, message)

        // Se houver anexo na resposta rápida, envia em seguida como uma nova mensagem.
        if (quickMessage.mediaPath) {
          const fileUrl = `${getBackendURL()}/public/${quickMessage.mediaPath}`
          const response = await fetch(fileUrl)
          const blob = await response.blob()
          const formData = new FormData()
          const fileName = quickMessage.mediaName || quickMessage.mediaPath

          formData.append('medias', blob, fileName)
          formData.append('body', fileName)
          formData.append('fromMe', 'true')

          await api.post(`/messages/${ticketId}`, formData)
        }
      } catch (err) {
        toastError(err)
      }

      setInputMessage('')
      setReplyingMessage(null)
      setEditingMessage(null)
      inputRef.current.focus()
    } else {
      setTimeout(() => {
        inputRef.current.focus()
        inputRef.current.scrollTop = inputRef.current.scrollHeight
      }, 200)
    }
  }

  const handleAddEmoji = e => {
    const emoji = e.native
    const input = inputRef.current // O inputRef já aponta para o elemento nativo via InputBase

    if (input) {
      // Pega a posição atual do cursor
      const start = input.selectionStart
      const end = input.selectionEnd

      // Fatiamos o texto atual para inserir o emoji no meio
      const textBefore = inputMessage.substring(0, start)
      const textAfter = inputMessage.substring(end)

      const newMessage = textBefore + emoji + textAfter

      setInputMessage(newMessage)
      setShowEmoji(false)

      // Truque Sênior: O setTimeout 0 garante que o foco e o cursor
      // sejam aplicados APÓS o React processar a renderização do novo texto.
      setTimeout(() => {
        input.focus()
        // Move o cursor para logo após o emoji inserido
        const newPos = start + emoji.length
        input.setSelectionRange(newPos, newPos)
      }, 0)
    } else {
      // Fallback: caso o ref falhe, apenas adiciona ao final
      setInputMessage(prevState => prevState + emoji)
    }
  }

  const handleInputPaste = e => {
    if (ticketStatus !== 'open' && !isGroup) {
      return
    }

    e.preventDefault()

    const clipboardData = e.clipboardData

    if (clipboardData.files && clipboardData.files.length > 0) {
      return
    }

    if (clipboardData.items && clipboardData.items.length > 0) {
      const items = Array.from(clipboardData.items)
      const imageItem = items.find(item => item.type.indexOf('image') !== -1)
      if (imageItem) {
        const blob = imageItem.getAsFile()
        if (blob) {
          return
        }
      }
    }
    const text = clipboardData.getData('text/plain')

    if (text) {
      const cursorPosition = inputRef.current.selectionStart
      const textBefore = inputMessage.substring(0, cursorPosition)
      const textAfter = inputMessage.substring(cursorPosition)

      setInputMessage(textBefore + text + textAfter)

      setTimeout(() => {
        const newPosition = cursorPosition + text.length
        if (inputRef.current && inputRef.current.setSelectionRange) {
          inputRef.current.setSelectionRange(newPosition, newPosition)
        }
      }, 0)
    }
  }

  const handleSendMessage = async () => {
    if (inputMessage.trim() === '') return
    setLoading(true)

    // Se a configuração de botão de assinatura estiver desabilitada, força a assinatura
    const shouldSign =
      !showSignatureButtonSetting || signMessage || internalNote

    const message = {
      read: 1,
      fromMe: true,
      mediaUrl: '',
      body: shouldSign
        ? `*${signatureLabel}:*\n${inputMessage.trim()}`
        : inputMessage.trim(),
      quotedMsg: replyingMessage,
      internal: internalNote
    }

    // setInternalNote(false)

    const url =
      editingMessage !== null
        ? `/messages/edit/${editingMessage.id}`
        : `/messages/${ticketId}`
    api.post(url, message).catch(err => {
      toastError(err)
    })

    setInputMessage('')
    setShowEmoji(false)
    setShowQuickMessages(false)
    setLoading(false)
    setReplyingMessage(null)
    setEditingMessage(null)
    inputRef.current.focus()
  }

  const hasCompanyPixConfig = companyPixConfigs.length > 0

  const pixTypeLabelMap = {
    cpf: 'CPF',
    cnpj: 'CNPJ',
    email: 'E-mail',
    phone: 'Telefone',
    random: 'Chave Aleatória'
  }

  const handleSendPixKey = async companyPixConfig => {
    if (!companyPixConfig) return

    const accountName = companyPixConfig.accountName.trim()
    const pixKey = companyPixConfig.key.trim()
    const pixType = companyPixConfig.type || 'cpf'
    const pixTypeLabel = pixTypeLabelMap[pixType] || 'Chave Pix'

    const nameParts = accountName.split(' ').filter(Boolean)
    const firstName = nameParts[0] || ''
    const lastName = nameParts.length > 1 ? nameParts[nameParts.length - 1] : ''

    const sanitizeVCardValue = value =>
      String(value || '')
        .replace(/\r\n|\r|\n/g, ' ')
        .replace(/;/g, '\\;')
        .replace(/,/g, '\\,')

    const formatDisplayNumber = number => {
      const cleanNumber = String(number || '').replace(/\D/g, '')

      if (cleanNumber.length === 13 && cleanNumber.startsWith('55')) {
        const countryCode = cleanNumber.substring(0, 2)
        const areaCode = cleanNumber.substring(2, 4)
        const firstPart = cleanNumber.substring(4, 9)
        const secondPart = cleanNumber.substring(9, 13)
        return `+${countryCode} ${areaCode} ${firstPart}-${secondPart}`
      }

      return cleanNumber ? `+${cleanNumber}` : ''
    }

    const waidNumber = (ticket?.contact?.number || '').replace(/\D/g, '')
    const formattedDisplayNumber = formatDisplayNumber(waidNumber)
    const telLine = waidNumber
      ? `TEL;type=CELL;waid=${waidNumber}:${formattedDisplayNumber}`
      : `TEL;type=CELL:${sanitizeVCardValue(pixKey)}`

    const vCardLines = [
      'BEGIN:VCARD',
      'VERSION:3.0',
      `N:${sanitizeVCardValue(lastName)};${sanitizeVCardValue(firstName)};;;`,
      `FN:${sanitizeVCardValue(accountName)}`,
      telLine,
      'item1.X-ABLabel:Celular',
      `X-WA-BIZ-NAME:${sanitizeVCardValue(accountName)}`,
      `X-WA-BIZ-DESCRIPTION:${sanitizeVCardValue(`${pixTypeLabel}: ${pixKey}`)}`,
      `NOTE:${sanitizeVCardValue(`Nome: ${accountName} | Tipo da Chave: ${pixTypeLabel} | Chave Pix: ${pixKey}`)}`,
      `X-TICKETZ-PIX-TYPE:${sanitizeVCardValue(pixType)}`,
      `X-TICKETZ-PIX-KEY:${sanitizeVCardValue(pixKey)}`,
      `X-TICKETZ-PIX-NAME:${sanitizeVCardValue(accountName)}`,
      'END:VCARD'
    ]

    const vCardString = vCardLines.join('\r\n')

    const message = {
      read: 1,
      fromMe: true,
      mediaUrl: '',
      body: vCardString,
      quotedMsg: replyingMessage,
      internal: internalNote
    }

    setLoading(true)
    try {
      await api.post(`/messages/${ticketId}`, message)
      setReplyingMessage(null)
      setEditingMessage(null)
      setShowQuickMessages(false)
      setShowEmoji(false)
      inputRef.current.focus()
    } catch (err) {
      toastError(err)
    } finally {
      setLoading(false)
    }
  }

  const handleOpenPixSelector = () => {
    if (!hasCompanyPixConfig) return
    setShowPixSelector(true)
  }

  const handleSendSelectedPixKey = async pixConfig => {
    setShowPixSelector(false)
    await handleSendPixKey(pixConfig)
  }

  // Envia a opção do menu de bot como mensagem simples, sem assinatura
  const handleSendBotMenuOption = async option => {
    const value = String(option || '').trim()
    if (!value) return
    setShowBotMenu(false)
    setBotReplyValue('')
    setLoading(true)
    try {
      await api.post(`/messages/${ticketId}`, {
        read: 1,
        fromMe: true,
        mediaUrl: '',
        body: value,
        quotedMsg: replyingMessage,
        internal: internalNote
      })
      setReplyingMessage(null)
      setEditingMessage(null)
      setShowQuickMessages(false)
      setShowEmoji(false)
      inputRef.current.focus()
    } catch (err) {
      toastError(err)
    } finally {
      setLoading(false)
    }
  }

  // const handleStartRecording = async () => {
  //   if (disableOption) return
  //   setLoading(true)
  //   try {
  //     await navigator.mediaDevices.getUserMedia({ audio: true })
  //     await Mp3Recorder.start()
  //     setRecording(true)
  //     setLoading(false)
  //   } catch (err) {
  //     toastError(err)
  //     setLoading(false)
  //   }
  // }

  const handleStartRecording = async () => {
    if (disableOption) return
    setLoading(true)
    try {
      // Cria a instância de gravação SÓ na hora do clique (evita áudio mudo)
      if (!mp3RecorderRef.current) {
        mp3RecorderRef.current = new MicRecorder({ bitRate: 128 })
      }
      await mp3RecorderRef.current.start()
      setRecording(true)
    } catch (err) {
      toastError(err)
    } finally {
      setLoading(false)
    }
  }

  const handleStopToPreview = async () => {
    setLoading(true)
    try {
      const [, blob] = await mp3RecorderRef.current.stop().getMp3()

      // Gera a URL para o Preview do player
      const url = URL.createObjectURL(blob)
      setAudioUrl(url)
      setRecordedBlob(blob)
      setRecording(false)
    } catch (err) {
      toastError(err)
    } finally {
      setLoading(false)
    }
  }

  // const handleUploadAudio = async () => {
  //   setLoading(true)
  //   try {
  //     const [, blob] = await Mp3Recorder.stop().getMp3()
  //     if (blob.size < 10000) {
  //       setLoading(false)
  //       setRecording(false)
  //       return
  //     }

  //     const formData = new FormData()
  //     const filename = `audio-record-site-${new Date().getTime()}.mp3`
  //     formData.append('medias', blob, filename)
  //     formData.append('body', filename)
  //     formData.append('fromMe', true)

  //     await api.post(`/messages/${ticketId}`, formData)
  //   } catch (err) {
  //     toastError(err)
  //   }

  //   setRecording(false)
  //   setLoading(false)
  // }

  const handleUploadAudio = () => {
    if (!recordedBlob) return

    const formData = new FormData()
    const filename = `audio-record-site-${new Date().getTime()}.mp3`
    formData.append('medias', recordedBlob, filename)
    formData.append('body', filename)
    formData.append('fromMe', true)

    const optimisticId = `optimistic-audio-${Date.now()}`
    const localAudioUrl = audioUrl

    const optimisticMessage = {
      id: optimisticId,
      ticketId,
      fromMe: true,
      body: filename,
      mediaUrl: localAudioUrl,
      mediaType: 'audio',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      ack: 0,
      isOptimistic: true,
      dataJson: JSON.stringify({})
    }

    messagesListRef.current?.addOptimisticMessage(optimisticMessage)

    // Libera a interface imediatamente para envio em segundo plano
    setAudioUrl(null)
    setRecordedBlob(null)
    if (inputRef.current) {
      inputRef.current.focus()
    }

    api.post(`/messages/${ticketId}`, formData).catch(err => {
      messagesListRef.current?.removeOptimisticMessage(optimisticId)
      toastError(err)
    })
  }

  // const handleCancelAudio = async () => {
  //   try {
  //     await Mp3Recorder.stop().getMp3()
  //     setRecording(false)
  //   } catch (err) {
  //     toastError(err)
  //   }
  // }

  const handleCancelAudio = async () => {
    try {
      // Para o gravador se ele ainda estiver rodando (botão cancelar vermelho)
      if (recording && mp3RecorderRef.current) {
        await mp3RecorderRef.current.stop().getMp3()
      }
      setRecording(false)
      setAudioUrl(null)
      setRecordedBlob(null)
    } catch (err) {
      toastError(err)
    }
  }

  const isGroup = showTabGroups && ticket.isGroup
  const linkedAttendantIds = Array.isArray(ticket?.users)
    ? ticket.users.map(item => item.id)
    : []
  const isMainAttendant = Number(ticket?.userId) === Number(user?.id)
  const isCoAttendant = linkedAttendantIds.includes(Number(user?.id))
  const isPartOfAttendance =
    isMainAttendant || isCoAttendant || joinedAttendance
  const shouldShowJoinAttendanceButton =
    ticketStatus === 'open' && !isPartOfAttendance

  const disableOption =
    recording ||
    (ticketStatus === 'pending' && !ticket.isGroup) ||
    ticketStatus === 'closed'

  const disableActions =
    recording ||
    internalNote ||
    (ticketStatus === 'pending' && !ticket.isGroup) ||
    ticketStatus === 'closed'

  const handleJoinAttendance = async () => {
    try {
      setJoiningAttendance(true)

      if (ticket?.userId && Number(ticket.userId) !== Number(user?.id)) {
        await api.post('/ticket-attendants', {
          ticketId: ticket.id,
          userId: user.id
        })
      } else {
        await api.put(`/tickets/${ticket.id}`, {
          status: ticket.status || 'open',
          userId: user.id
        })
      }

      setJoinedAttendance(true)
    } catch (err) {
      toastError(err)
    } finally {
      setJoiningAttendance(false)
    }
  }

  const renderReplyingMessage = message => {
    return (
      <div className={classes.replyginMsgWrapper}>
        <div className={classes.replyginMsgContainer}>
          <span
            className={clsx(classes.replyginContactMsgSideColor, {
              [classes.replyginSelfMsgSideColor]: !message.fromMe
            })}
          ></span>
          {replyingMessage && (
            <div className={classes.replyginMsgBody}>
              <span className={classes.messageContactName}>
                {i18n.t('messagesInput.replying')} {message.contact?.name}
              </span>
              <MarkdownWrapper>
                {message.mediaType === 'audio'
                  ? 'Áudio'
                  : message.body.startsWith('{"ticketzvCard":') ||
                    (message.body.startsWith('BEGIN:VCARD') &&
                      message.body.includes('END:VCARD'))
                    ? '📇 Cartão de contato'
                    : message.body}
              </MarkdownWrapper>
            </div>
          )}
          {editingMessage && (
            <div className={classes.replyginMsgBody}>
              <span className={classes.messageContactName}>
                {i18n.t('messagesInput.editing')}
              </span>
              <MarkdownWrapper>{message.body}</MarkdownWrapper>
            </div>
          )}
        </div>
        <IconButton
          aria-label="showRecorder"
          component="span"
          disabled={disableOption}
          onClick={() => {
            setReplyingMessage(null)
            setEditingMessage(null)
            setInputMessage('')
          }}
        >
          <ClearIcon className={classes.sendMessageIcons} />
        </IconButton>
      </div>
    )
  }

  const renderBotReplyInput = () => {
    return (
      <Popover
        open={showBotMenu}
        onClose={() => {
          closeBotReply()
          setBotReplyValue('')
        }}
        anchorReference={
          botReplyState.position ? 'anchorPosition' : 'anchorEl'
        }
        anchorPosition={botReplyState.position || undefined}
        anchorEl={!botReplyState.position ? inputRef.current : undefined}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            padding: '8px 10px'
          }}
        >
          <span
            style={{
              fontSize: 13,
              opacity: 0.7,
              marginBottom: 4,
              whiteSpace: 'nowrap'
            }}
          >
            Por favor, digite a opção referente ao menu do bot
          </span>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8
            }}
          >
            <BotMessageSquare size={18} />
            <InputBase
              autoFocus
              placeholder="Digite o número da opção do bot"
              value={botReplyValue}
              onChange={e =>
                setBotReplyValue(e.target.value.replace(/\D/g, ''))
              }
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  e.preventDefault()
                  handleSendBotMenuOption(botReplyValue)
                }
              }}
              style={{ width: 210 }}
              inputProps={{
                inputMode: 'numeric',
                pattern: '[0-9]*',
                'aria-label': 'Digite o número da opção do bot'
              }}
              disabled={loading}
            />
            <IconButton
              aria-label="sendBotReply"
              component="span"
              size="small"
              disabled={loading || !botReplyValue}
              onClick={() => handleSendBotMenuOption(botReplyValue)}
            >
              <Send size={16} className={classes.sendMessageIcons} />
            </IconButton>
            <IconButton
              aria-label="closeBotReply"
              component="span"
              size="small"
              onClick={() => {
                closeBotReply()
                setBotReplyValue('')
              }}
            >
              <ClearIcon fontSize="small" className={classes.sendMessageIcons} />
            </IconButton>
          </div>
        </div>
      </Popover>
    )
  }

  const UploadButton = props => {
    const { disabled, handleClick } = props
    const classes = useStyles()
    return (
      <Tooltip title={'Upload de Arquivos'}>
        <IconButton
          aria-label="uploadFiles"
          component="span"
          disabled={disabled}
          onClick={handleClick}
          className={classes.actionsIconButton}
        >
          <Paperclip className={classes.buttonActionFile} size={22} />
        </IconButton>
      </Tooltip>
    )
  }

  const handleUploadClick = () => {
    if (fileInputRef && fileInputRef.current) {
      fileInputRef.current.click()
    }
  }

  // const handleInputChange = newValue => {
  //   setInputMessage(newValue)
  // }

  const ContactPickerModal = props => {
    const { open, onClose, onSelectContact, disabled } = props
    const classes = useStyles()
    const [contacts, setContacts] = useState([])
    const [loading, setLoading] = useState(false)
    const [loadingMore, setLoadingMore] = useState(false)
    const [searchParam, setSearchParam] = useState('')
    const [currentPage, setCurrentPage] = useState(1)
    const [hasMore, setHasMore] = useState(true)
    const listRef = useRef(null)

    const debouncedSearchParam = useDebounce(searchParam, 500)

    useEffect(() => {
      if (open) {
        setContacts([])
        setCurrentPage(1)
        setHasMore(true)
        fetchContacts(1, true)
      }
    }, [open, debouncedSearchParam])

    const fetchContacts = async (page = 1, reset = false) => {
      if (disabled) return
      setLoading(true)

      if (page === 1) {
        setLoading(true)
      } else {
        setLoadingMore(true)
      }

      try {
        const { data } = await api.get('/contacts/', {
          params: { searchParam: debouncedSearchParam, pageNumber: page }
        })

        if (reset) {
          setContacts(data.contacts)
        } else {
          setContacts(prev => [...prev, ...data.contacts])
        }

        // Verifica se ainda há mais contatos para carregar
        setHasMore(data.contacts.length === 20)
        setCurrentPage(page)
      } catch (err) {
        toastError(err)
      } finally {
        setLoading(false)
        setLoadingMore(false)
      }
    }

    const handleScroll = event => {
      const { scrollTop, scrollHeight, clientHeight } = event.target

      // Verifica se chegou ao final da lista (com uma margem de 5px)
      if (
        scrollHeight - scrollTop <= clientHeight + 5 &&
        hasMore &&
        !loadingMore &&
        !loading
      ) {
        fetchContacts(currentPage + 1, false)
      }
    }

    const handleSelectContact = contact => {
      onSelectContact(contact)
      onClose()
    }

    const handleSearch = event => {
      setSearchParam(event.target.value.toLowerCase())
    }

    return (
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="xs"
        fullWidth
        className={classes.dialog}
      >
        <DialogTitle className={classes.dialogTitle}>
          Enviar Contato
        </DialogTitle>

        <DialogContent dividers className={classes.dialogContent}>
          <div className={classes.listContactsContainer}>
            <InputFieldText
              fullWidth
              placeholder="Pesquisar contato..."
              type="search"
              name={'searchContact'}
              value={searchParam}
              onChange={handleSearch}
              margin="dense"
              variant="outlined"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon className={classes.searchIcon} />
                  </InputAdornment>
                )
              }}
            />

            {loading && !loadingMore ? (
              <div className={classes.listContacts}>
                <CircularProgress />
              </div>
            ) : (
              <div
                className={classes.listContactsContent}
                onScroll={handleScroll}
                ref={listRef}
              >
                <List>
                  {contacts.map(contact => (
                    <ListItem
                      key={`contact-${contact.id}`}
                      button
                      onClick={() => handleSelectContact(contact)}
                      className={classes.contactListItem}
                    >
                      <ListItemAvatar>
                        <Avatar
                          style={{
                            backgroundColor: generateColor(contact.number)
                          }}
                        >
                          {getInitials(contact.name)}
                        </Avatar>
                      </ListItemAvatar>

                      <ListItemText
                        primary={contact.name}
                        secondary={contact.number}
                        className={classes.contactListItemText}
                      />
                    </ListItem>
                  ))}
                </List>

                {loadingMore && (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      padding: '10px'
                    }}
                  >
                    <CircularProgress size={24} />
                  </div>
                )}

                {!hasMore && contacts.length > 0 && (
                  <div className={classes.noMoreContacts}>
                    Todos os contatos foram carregados.
                  </div>
                )}
              </div>
            )}
          </div>
        </DialogContent>

        <DialogActions>
          <ButtonSecondary
            onClick={onClose}
            color="secondary"
            label="Cancelar"
          />
        </DialogActions>
      </Dialog>
    )
  }

  const ContactPickerButton = props => {
    const { disabled, onClick } = props
    const classes = useStyles()
    return (
      <Tooltip title="Enviar contato" placement="right" arrow>
        <IconButton
          aria-label="contactPicker"
          component="span"
          disabled={disabled}
          onClick={onClick}
          className={classes.actionsIconButton}
        >
          <CircleUserRound className={classes.buttonActionContact} size={22} />
        </IconButton>
      </Tooltip>
    )
  }

  const PixButton = props => {
    const { disabled, onClick } = props
    const classes = useStyles()

    return (
      <Tooltip title="Enviar chave Pix" placement="right" arrow>
        <IconButton
          aria-label="sendPixKey"
          component="span"
          disabled={disabled}
          onClick={onClick}
          className={classes.actionsIconButton}
        >
          {/* <span className={classes.buttonActionPix}>Pix</span> */}
          <IconPix className={classes.actionIconButtonPix} />
        </IconButton>
      </Tooltip>
    )
  }

  // const ContactFilesButton = props => {
  //   const { disabled } = props
  //   const classes = useStyles()
  //   return (
  //     <Tooltip title="Enviar arquivo ou link" placement="right" arrow>
  //       <IconButton
  //         aria-label="contactFilesLink"
  //         component="span"
  //         disabled={disabled}
  //         onClick={() => setShowContactFilesOptions(true)}
  //         className={classes.actionsIconButton}
  //       >
  //         <Paperclip className={classes.buttonActionFile} size={22} />
  //       </IconButton>
  //     </Tooltip>
  //   )
  // }

  const handleSendContactFilesLink = async () => {
    setLoading(true)
    try {
      await api.get(`/contact-files/link/${ticketId}`)
      setShowContactFilesOptions(false)
    } catch (err) {
      toastError(err)
    } finally {
      setLoading(false)
    }
  }

  const ContactFilesOptionsModal = props => {
    const { open, onClose } = props
    const classes = useStyles()

    return (
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="xs"
        fullWidth
        className={classes.dialog}
      >
        <DialogTitle className={classes.dialogTitle}>
          Arquivos de Contato
        </DialogTitle>

        <DialogContent className={classes.dialogContent}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              padding: '16px 0'
            }}
          >
            <ButtonSecondary
              onClick={() => {
                handleSendContactFilesLink()
              }}
              color="primary"
              label="Enviar link da pasta"
              style={{ width: '100%' }}
            />
            <ButtonSecondary
              onClick={() => {
                setShowFilesList(true)
                onClose()
              }}
              color="primary"
              label="Enviar arquivo"
              style={{ width: '100%' }}
            />
          </div>
        </DialogContent>

        <DialogActions>
          <ButtonSecondary
            onClick={onClose}
            color="secondary"
            label="Cancelar"
          />
        </DialogActions>
      </Dialog>
    )
  }

  const FilesList = props => {
    const { open, onClose, onSelectFile } = props
    const classes = useStyles()
    const [files, setFiles] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
      if (open) {
        fetchFiles()
      }
    }, [open])

    const fetchFiles = async () => {
      setLoading(true)
      try {
        // Buscar arquivos gerais do sistema
        const { data } = await api.get(`/files`)

        console.log('Files data:', data)

        let filesList = []

        // Pode vir como data.files ou diretamente como array
        if (data.files && Array.isArray(data.files)) {
          filesList = data.files
        } else if (Array.isArray(data)) {
          filesList = data
        }

        console.log('Parsed files list:', filesList)
        setFiles(filesList)
      } catch (err) {
        console.error('Error fetching files:', err)
        toastError(err)
        setFiles([])
      } finally {
        setLoading(false)
      }
    }

    const handleSelectFile = file => {
      onSelectFile(file)
      onClose()
    }

    return (
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="xs"
        fullWidth
        className={classes.dialog}
      >
        <DialogTitle className={classes.dialogTitle}>
          Selecione um Arquivo
        </DialogTitle>

        <DialogContent dividers className={classes.dialogContent}>
          {loading ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                padding: '20px'
              }}
            >
              <CircularProgress />
            </div>
          ) : files.length > 0 ? (
            <List>
              {files.map(file => (
                <ListItem
                  key={`file-${file.url}`}
                  button
                  onClick={() => handleSelectFile(file)}
                  className={classes.contactListItem}
                >
                  <ListItemText
                    primary={file.name || file.fileName || 'Arquivo'}
                    className={classes.contactListItemText}
                  />
                </ListItem>
              ))}
            </List>
          ) : (
            <div
              style={{
                textAlign: 'center',
                padding: '20px',
                color: '#999'
              }}
            >
              Nenhum arquivo encontrado
            </div>
          )}
        </DialogContent>

        <DialogActions>
          <ButtonSecondary
            onClick={onClose}
            color="secondary"
            label="Cancelar"
          />
        </DialogActions>
      </Dialog>
    )
  }

  const handleSendFile = async file => {
    setLoading(true)
    try {
      const message = {
        read: 1,
        fromMe: true,
        mediaUrl: '',
        body: `${file.name || 'Arquivo'}: ${file.url}`,
        quotedMsg: replyingMessage,
        internal: internalNote
      }

      await api.post(`/messages/${ticketId}`, message)
      setShowFilesList(false)
    } catch (err) {
      toastError(err)
    } finally {
      setLoading(false)
    }
  }

  const handleSendContact = async contact => {
    setLoading(true)
    try {
      // Formatar número para exibição no vCard (sempre com + e formatação)
      let displayNumber = contact.number
      if (!displayNumber.startsWith('+')) {
        displayNumber = `+${displayNumber}`
      }

      // Formatar o número para exibição visual (ex: +55 67 9978-4701)
      const formatDisplayNumber = number => {
        // Remove todos os caracteres não numéricos
        const cleanNumber = number.replace(/\D/g, '')

        // Se tem 13 dígitos (55 + DDD + número), formata como brasileiro
        if (cleanNumber.length === 13 && cleanNumber.startsWith('55')) {
          const countryCode = cleanNumber.substring(0, 2) // 55
          const areaCode = cleanNumber.substring(2, 4) // DDD
          const firstPart = cleanNumber.substring(4, 9) // primeiros 5 dígitos
          const secondPart = cleanNumber.substring(9, 13) // últimos 4 dígitos
          return `+${countryCode} ${areaCode} ${firstPart}-${secondPart}`
        }

        // Para outros formatos, apenas adiciona o +
        return displayNumber
      }

      const formattedDisplayNumber = formatDisplayNumber(displayNumber)

      // Número para waid (WhatsApp ID) - sempre sem + e sem formatação
      const waidNumber = contact.number.replace(/\D/g, '')

      // Separar nome em partes (último nome e primeiro nome)
      const nameParts = contact.name.trim().split(' ')
      const firstName = nameParts[0] || ''
      const lastName =
        nameParts.length > 1 ? nameParts[nameParts.length - 1] : ''

      // Formatar número baseado na origem do ticket (para quando o contato for adicionado)
      let contactNumber = contact.number
      if (ticket.whatsappId) {
        // Para WhatsApp: formato "+556799432812"
        if (!contactNumber.startsWith('+')) {
          contactNumber = `+${contactNumber}`
        }
      } else {
        // Para sistema: formato "67999432812" (sem +)
        if (contactNumber.startsWith('+')) {
          contactNumber = contactNumber.substring(1)
        }
      }

      // Criar vCard no formato solicitado
      const vCardString = `BEGIN:VCARD\nVERSION:3.0\nN:${lastName};${firstName};;;\nFN:${contact.name}\nTEL;type=CELL;waid=${waidNumber}:${formattedDisplayNumber}\nEND:VCARD`

      const message = {
        read: 1,
        fromMe: true,
        mediaUrl: '',
        body: vCardString,
        quotedMsg: replyingMessage,
        internal: internalNote
      }

      await api.post(`/messages/${ticketId}`, message)
      setShowContactPicker(false)
    } catch (err) {
      toastError(err)
    } finally {
      setLoading(false)
    }
  }

  const CameraButton = props => {
    const { disabled, onClick } = props
    const classes = useStyles()
    return (
      <Tooltip title="Câmera" placement="right" arrow>
        <IconButton
          aria-label="cameraCapture"
          component="span"
          disabled={disabled}
          onClick={onClick}
          className={classes.actionsIconButton}
        >
          <Camera className={classes.buttonActionFile} size={22} />
        </IconButton>
      </Tooltip>
    )
  }

  const CameraModal = props => {
    const { open, onClose, onCapture } = props
    const classes = useStyles()
    const theme = useTheme()
    const videoRef = useRef(null)
    const canvasRef = useRef(null)
    const mediaStreamRef = useRef(null)
    const mediaRecorderRef = useRef(null)

    const [isCameraStarted, setIsCameraStarted] = useState(false)
    const [isRecording, setIsRecording] = useState(false)
    const [recordingTime, setRecordingTime] = useState(0)
    const [mediaMode, setMediaMode] = useState('photo') // 'photo' ou 'video'
    const [cameraError, setCameraError] = useState(null)
    const recordingTimerRef = useRef(null)

    useEffect(() => {
      if (open) {
        startCamera()
      } else {
        stopCamera()
      }

      return () => {
        stopCamera()
      }
    }, [open, mediaMode])

    const startCamera = async () => {
      try {
        setCameraError(null)

        // Se já existe uma stream, para antes de criar uma nova
        if (mediaStreamRef.current) {
          mediaStreamRef.current.getTracks().forEach(track => {
            track.stop()
          })
        }

        const constraints = {
          video: {
            // facingMode: 'user',
            facingMode: 'environment',
            width: { ideal: 1280 },
            height: { ideal: 720 }
          },
          audio: mediaMode === 'video' // Audio é necessário para vídeo
        }

        const stream = await navigator.mediaDevices.getUserMedia(constraints)
        mediaStreamRef.current = stream

        if (videoRef.current) {
          videoRef.current.srcObject = stream

          // Aguarda o vídeo estar pronto antes de marcar como iniciado
          const playVideo = () => {
            if (videoRef.current) {
              videoRef.current
                .play()
                .then(() => {
                  setIsCameraStarted(true)

                  // Inicializa o MediaRecorder se em modo vídeo
                  if (
                    mediaMode === 'video' &&
                    mediaRecorderRef.current === null
                  ) {
                    try {
                      const mediaRecorder = new MediaRecorder(stream, {
                        mimeType: 'video/webm;codecs=vp8,opus'
                      })
                      mediaRecorderRef.current = mediaRecorder

                      const chunks = []
                      mediaRecorder.ondataavailable = e => {
                        if (e.data.size > 0) {
                          chunks.push(e.data)
                        }
                      }

                      mediaRecorder.onstop = () => {
                        const blob = new Blob(chunks, { type: 'video/webm' })
                        const timestamp = new Date().getTime()
                        const filename = `video-${timestamp}.webm`
                        onCapture(blob, filename, 'video')
                        onClose()
                      }

                      mediaRecorder.onerror = event => {
                        console.error('Erro no MediaRecorder:', event.error)
                        setCameraError('Erro ao gravar vídeo: ' + event.error)
                      }
                    } catch (err) {
                      console.error('Erro ao criar MediaRecorder:', err)
                      setCameraError('Erro ao configurar gravação de vídeo')
                    }
                  }
                })
                .catch(err => {
                  console.error('Erro ao reproduzir vídeo:', err)
                  setCameraError('Erro ao iniciar a câmera')
                })
            }
          }

          if (videoRef.current.readyState >= 2) {
            // Video já está carregado
            playVideo()
          } else {
            videoRef.current.onloadedmetadata = playVideo
          }
        }
      } catch (err) {
        console.error('Erro ao acessar câmera:', err)
        let errorMsg = 'Erro ao acessar a câmera'

        if (err.name === 'NotAllowedError') {
          errorMsg =
            'Permissão de câmera foi negada. Verifique as configurações do navegador.'
        } else if (err.name === 'NotFoundError') {
          errorMsg = 'Nenhuma câmera foi encontrada no dispositivo.'
        } else if (err.name === 'NotReadableError') {
          errorMsg = 'A câmera está sendo usada por outro programa.'
        } else if (err.name === 'TypeError') {
          errorMsg = 'Tipo de mídia não suportado.'
        }

        setCameraError(errorMsg)
        toastError(errorMsg)
      }
    }

    const stopCamera = () => {
      if (mediaStreamRef.current) {
        mediaStreamRef.current.getTracks().forEach(track => {
          track.stop()
        })
        mediaStreamRef.current = null
      }

      if (mediaRecorderRef.current) {
        if (mediaRecorderRef.current.state === 'recording') {
          mediaRecorderRef.current.stop()
        }
        mediaRecorderRef.current = null
      }

      setIsCameraStarted(false)
      setIsRecording(false)
      setRecordingTime(0)
      if (recordingTimerRef.current) {
        clearInterval(recordingTimerRef.current)
      }
    }

    const capturePhoto = () => {
      if (videoRef.current && canvasRef.current) {
        const context = canvasRef.current.getContext('2d')
        canvasRef.current.width = videoRef.current.videoWidth
        canvasRef.current.height = videoRef.current.videoHeight
        context.drawImage(
          videoRef.current,
          0,
          0,
          videoRef.current.videoWidth,
          videoRef.current.videoHeight
        )

        canvasRef.current.toBlob(
          blob => {
            const timestamp = new Date().getTime()
            const filename = `photo-${timestamp}.jpg`
            onCapture(blob, filename, 'photo')
            onClose()
          },
          'image/jpeg',
          0.9
        )
      }
    }

    const startRecording = () => {
      if (
        mediaRecorderRef.current &&
        mediaRecorderRef.current.state === 'inactive'
      ) {
        try {
          mediaRecorderRef.current.start()
          setIsRecording(true)
          setRecordingTime(0)

          recordingTimerRef.current = setInterval(() => {
            setRecordingTime(prev => prev + 1)
          }, 1000)
        } catch (err) {
          console.error('Erro ao iniciar gravação:', err)
          setCameraError('Erro ao iniciar gravação: ' + err.message)
        }
      } else {
        console.warn('MediaRecorder não está pronto')
        setCameraError('Câmera não está pronta. Tente novamente.')
      }
    }

    const stopRecording = () => {
      if (
        mediaRecorderRef.current &&
        mediaRecorderRef.current.state === 'recording'
      ) {
        try {
          mediaRecorderRef.current.stop()
          setIsRecording(false)
          if (recordingTimerRef.current) {
            clearInterval(recordingTimerRef.current)
          }
        } catch (err) {
          console.error('Erro ao parar gravação:', err)
          setCameraError('Erro ao parar gravação: ' + err.message)
        }
      }
    }

    const formatTime = seconds => {
      const mins = Math.floor(seconds / 60)
      const secs = seconds % 60
      return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
    }

    const handleModeChange = mode => {
      if (!isRecording) {
        setMediaMode(mode)
        // A câmera será reinicializada pelo useEffect que monitora mediaMode
      }
    }

    return (
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="xs"
        fullWidth
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        className={classes.dialog}
      >
        <DialogTitle
          className={classes.dialogTitle}
          style={{ cursor: 'move', userSelect: 'none', padding: '12px 24px' }}
          id="draggable-dialog-title"
        >
          {mediaMode === 'photo' ? 'Capturar Foto' : 'Gravar Vídeo'}
        </DialogTitle>

        <DialogContent dividers className={classes.dialogContent}>
          <div className={classes.cameraModalContent}>
            {cameraError ? (
              <div className={classes.cameraModalError}>{cameraError}</div>
            ) : (
              <div className={classes.cameraModalStart}>
                {!isCameraStarted && (
                  <span>
                    <Camera size={26} /> Inicializando câmera...
                  </span>
                )}
                <video
                  ref={videoRef}
                  autoPlay
                  muted
                  playsInline
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    display: isCameraStarted ? 'block' : 'none'
                  }}
                />
                <canvas ref={canvasRef} style={{ display: 'none' }} />
              </div>
            )}

            {isRecording && (
              <div className={classes.cameraModalRecording}>
                <VideoIcon />
                Gravando: {formatTime(recordingTime)}
              </div>
            )}

            <div
              style={{
                display: 'flex',
                gap: '8px',
                justifyContent: 'center'
              }}
            >
              <button
                onClick={() => handleModeChange('photo')}
                className={classes.buttonPhoto}
                style={{
                  backgroundColor:
                    mediaMode === 'photo'
                      ? theme.palette.blue_300.main
                      : theme.palette.gray_100.main,
                  color:
                    mediaMode === 'photo'
                      ? theme.palette.white_100.main
                      : theme.palette.gray_400.main,
                  cursor:
                    !isRecording && mediaMode !== 'photo'
                      ? 'pointer'
                      : 'default'
                }}
                disabled={isRecording}
              >
                <Camera size={20} /> Foto
              </button>
              <button
                onClick={() => handleModeChange('video')}
                className={classes.buttonPhoto}
                style={{
                  backgroundColor:
                    mediaMode === 'video'
                      ? theme.palette.blue_300.main
                      : theme.palette.gray_100.main,
                  color:
                    mediaMode === 'video'
                      ? theme.palette.white_100.main
                      : theme.palette.gray_400.main,
                  cursor:
                    !isRecording && mediaMode !== 'video'
                      ? 'pointer'
                      : 'default'
                }}
                disabled={isRecording}
              >
                <VideoIcon size={20} />
                Vídeo
              </button>
            </div>
          </div>
        </DialogContent>

        <DialogActions>
          {mediaMode === 'photo' ? (
            <>
              <ButtonSecondary
                onClick={onClose}
                color="secondary"
                label="Cancelar"
              />
              <Button className={classes.buttonCapture} onClick={capturePhoto}>
                <Camera size={20} />
                Capturar
              </Button>
            </>
          ) : (
            <>
              <ButtonSecondary
                onClick={onClose}
                color="secondary"
                label="Cancelar"
              />
              {!isRecording ? (
                <Button
                  className={classes.buttonCapture}
                  onClick={startRecording}
                >
                  {' '}
                  <VideoIcon size={20} />
                  Iniciar
                </Button>
              ) : (
                <Button
                  onClick={stopRecording}
                  className={clsx(classes.buttonCapture, classes.buttonStop)}
                >
                  <CircleStop size={20} /> Parar
                </Button>
              )}
            </>
          )}
        </DialogActions>
      </Dialog>
    )
  }

  const handleSendMedia = async (blob, filename, type) => {
    setLoading(true)
    try {
      const formData = new FormData()
      formData.append('medias', blob, filename)
      formData.append('body', filename)
      formData.append('fromMe', true)

      await api.post(`/messages/${ticketId}`, formData)
      setShowCamera(false)
    } catch (err) {
      toastError(err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      <UploadDropZone
        ticketId={ticketId}
        ticket={ticket}
        fileInputRef={fileInputRef}
        parentDrawerOpen={parentDrawerOpen}
      >
        <Paper square elevation={0} className={classes.mainWrapper}>
          {(replyingMessage && renderReplyingMessage(replyingMessage)) ||
            (editingMessage && renderReplyingMessage(editingMessage))}
          {showBotMenu && renderBotReplyInput()}
          {ticketStatus === 'pending' &&
            !isGroup &&
            canShowManagementButtons &&
            isMobile && (
              <div className={classes.pendingButtonsWrapper}>
                <ButtonPrimary
                  loading={loading}
                  onClick={handleOpenTransferModal}
                  label={i18n.t('messagesList.header.buttons.transfer')}
                  icon={UserRoundArrowLeft}
                  style={{ height: 35, width: 135, maxWidth: 135, fontSize: 12, gap: 8 }}
                />
                <ButtonAddNew
                  loading={loading}
                  onClick={e => {
                    if (ticket.chatbot) {
                      setNewTicketModalOpen(true)
                    } else {
                      handleUpdateTicketStatus(e, 'open', user?.id)
                    }
                  }}
                  style={{ height: 35, width: 135, maxWidth: 135, fontSize: 12 }}
                  label={i18n.t('messagesList.header.buttons.accept')}
                  startIcon={<CircleCheck size={16} />}
                />
              </div>
            )}

          {ticketStatus === 'pending' && !isGroup ? (
            <div className={classes.boxClosedTicket}>
              {i18n.t('messagesInput.placeholderClosed')}
            </div>
          ) : shouldShowJoinAttendanceButton ? (
            <div className={classes.joinAttendanceWrapper}>
              <ButtonPrimary
                className={classes.joinAttendanceButton}
                variant="contained"
                color="primary"
                onClick={handleJoinAttendance}
                disabled={joiningAttendance}
                startIcon={
                  joiningAttendance ? <CircularProgress size={16} /> : null
                }
                label={
                  joiningAttendance
                    ? 'Adicionando...'
                    : 'Participar do Atendimento'
                }
              />
            </div>
          ) : (
            <div className={classes.messageBox}>
              <EmojiOptions
                disabled={disableActions}
                handleAddEmoji={handleAddEmoji}
                showEmoji={showEmoji}
                setShowEmoji={setShowEmoji}
              />
              <QuickMessageOptions
                disabled={disableActions}
                quickMessages={quickMessages}
                onSelectMessage={handleSelectQuickMessage}
                showQuickMessages={showQuickMessages}
                setShowQuickMessages={setShowQuickMessages}
                loadQuickMessages={loadQuickMessages}
                isTypingSlash={isTypingSlash}
                inputMessage={inputMessage}
                hideIcon={true}
              />
              {!isMobile && (
                <div className={classes.sideMenu}>
                  {/* Oculto Template */}
                  {/* <p onClick={() => {
                   api.post(`/omni/executeTicketAction/${ticketId}/sendTemplate:suporte`).catch(err => {
                      toastError(err)
                    })
                  }
                }>A</p> */}
                  <Tooltip title="Emoji" placement="right" arrow>
                    <IconButton
                      className={classes.actionsIconButton}
                      disabled={disableActions}
                      onClick={() => setShowEmoji(prevState => !prevState)}
                    >
                      <Smile className={classes.buttonActionEmoji} />
                    </IconButton>
                  </Tooltip>

                  {hasCompanyPixConfig && (
                    <PixButton
                      disabled={disableActions}
                      onClick={handleOpenPixSelector}
                    />
                  )}

                  <Tooltip title="Responder menu de bot" placement="right" arrow>
                    <IconButton
                      aria-label="botMenuReply"
                      component="span"
                      disabled={disableActions}
                      onClick={e =>
                        openBotReply({ top: e.clientY, left: e.clientX })
                      }
                      className={classes.actionsIconButton}
                    >
                      <BotMessageSquare
                        className={classes.buttonActionBot}
                        size={22}
                      />
                    </IconButton>
                  </Tooltip>

                  <UploadButton
                    disabled={disableActions}
                    handleClick={handleUploadClick}
                  />

                  <CameraButton
                    disabled={disableActions}
                    onClick={() => setShowCamera(true)}
                  />

                  <ContactPickerButton
                    disabled={disableActions}
                    onClick={() => setShowContactPicker(true)}
                  />

                  {/* <ContactFilesButton disabled={disableActions} /> */}

                  <Tooltip title="Mensagens Rápidas" placement="right" arrow>
                    <IconButton
                      className={classes.actionsIconButton}
                      disabled={disableActions}
                      onClick={async () => {
                        if (quickMessages.length === 0) {
                          await loadQuickMessages()
                        }
                        setShowQuickMessages(true)
                      }}
                    >
                      <Zap className={classes.buttonActionEmoji} size={22} />
                    </IconButton>
                  </Tooltip>
                  <IconSwitch
                    value={internalNote}
                    setter={setInternalNote}
                    tooltip={'Anotação Privada'}
                  >
                    <ShieldBan
                      className={classes.buttonIconSignature}
                      size={22}
                    />
                  </IconSwitch>

                  {showSignatureButtonSetting && (
                    <IconSwitch
                      value={signMessage}
                      setter={setSignMessage}
                      tooltip={'Assinatura'}
                    >
                      <Signature
                        className={classes.buttonIconSignature}
                        size={22}
                      />
                    </IconSwitch>
                  )}
                </div>
              )}
              {internalNote && (
                <div className={classes.messagePrivateMessage}>
                  <ShieldBan
                    className={classes.messagePrivateIcon}
                    size={isMobile ? 30 : 18}
                  />
                  <span className={classes.messagePrivateText}>
                    Mensagem privada ativada, o que você escrever não será
                    entregue, será sua anotação.
                  </span>
                </div>
              )}

              <div
                className={[
                  clsx(classes.newMessageBox, {
                    [classes.messagePrivate]: internalNote
                  })
                ]}
              >
                {/* BOTÃO DO MENU (Visível no Mobile ou opcionalmente em ambos) */}
                {isMobile && (
                  <Menu
                    anchorEl={anchorEl}
                    open={menuOpen}
                    onClose={handleCloseMenu}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'center'
                    }}
                    // Isso define qual parte do menu se alinha ao ponto acima
                    transformOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center'
                    }}
                    // Importante para não cobrir o ícone
                    getContentAnchorEl={null}
                    PaperProps={{
                      style: {
                        width: '250px'
                      }
                    }}
                  >
                    {/* OPÇÃO EMOJI */}
                    {/* <MenuItem
                        onClick={() => {
                          setShowEmoji(true)
                          handleCloseMenu()
                        }}
                        className={classes.menuItem}
                      >
                        <ListItemIcon>
                          <Smile size={20} />
                        </ListItemIcon>
                        <ListItemText primary="Emoji" />
                      </MenuItem> */}

                    {/* OPÇÃO MENSAGEM RÁPIDA */}
                    <MenuItem
                      onClick={async () => {
                        if (quickMessages.length === 0) {
                          await loadQuickMessages()
                        }
                        setShowQuickMessages(true)
                        handleCloseMenu()
                      }}
                      className={classes.menuItem}
                    >
                      <ListItemIcon>
                        <Zap size={20} />
                      </ListItemIcon>
                      <ListItemText primary="Respostas Rápidas" />
                    </MenuItem>

                    {/* OPÇÃO UPLOAD */}
                    <MenuItem
                      onClick={() => executeAction(handleUploadClick)}
                      className={classes.menuItem}
                    >
                      <ListItemIcon>
                        <Paperclip size={20} />
                      </ListItemIcon>
                      <ListItemText primary="Arquivos" />
                    </MenuItem>

                    {hasCompanyPixConfig && (
                      <MenuItem
                        onClick={() => executeAction(handleOpenPixSelector)}
                        className={classes.menuItem}
                      >
                        <ListItemIcon>
                          <span className={classes.buttonActionPix}>Pix</span>
                        </ListItemIcon>
                        <ListItemText primary="Enviar chave Pix" />
                      </MenuItem>
                    )}

                    {/* OPÇÃO RESPONDER MENU DE BOT */}
                    <MenuItem
                      onClick={() => executeAction(() => setShowBotMenu(true))}
                      className={classes.menuItem}
                    >
                      <ListItemIcon>
                        <BotMessageSquare size={20} />
                      </ListItemIcon>
                      <ListItemText primary="Responder menu de bot" />
                    </MenuItem>

                    {/* OPÇÃO CÂMERA */}
                    {/* <MenuItem
                        onClick={() => executeAction(() => setShowCamera(true))}
                        className={classes.menuItem}
                      >
                        <ListItemIcon>
                          <Camera size={20} />
                        </ListItemIcon>
                        <ListItemText primary="Câmera" />
                      </MenuItem> */}

                    {/* OPÇÃO CONTATO */}
                    <MenuItem
                      onClick={() =>
                        executeAction(() => setShowContactPicker(true))
                      }
                      className={classes.menuItem}
                    >
                      <ListItemIcon>
                        <CircleUserRound size={20} />
                      </ListItemIcon>
                      <ListItemText primary="Contato" />
                    </MenuItem>

                    {/* OPÇÃO NOTA INTERNA (Toggle) */}
                    <MenuItem
                      onClick={() =>
                        executeAction(() => setInternalNote(!internalNote))
                      }
                      className={classes.menuItem}
                    >
                      <ListItemIcon>
                        <ShieldBan size={20} />
                      </ListItemIcon>
                      <ListItemText primary="Mensagem Privada" />
                    </MenuItem>
                  </Menu>
                )}

                {!audioUrl ? (
                  <CustomInput
                    loading={loading}
                    inputRef={inputRef}
                    ticketStatus={(isGroup && 'open') || ticketStatus}
                    inputMessage={inputMessage}
                    setInputMessage={setInputMessage}
                    handleSendMessage={handleSendMessage}
                    handleInputPaste={handleInputPaste}
                    disableOption={disableOption}
                    quickMessages={quickMessages}
                    showQuickMessages={showQuickMessages}
                    setShowQuickMessages={setShowQuickMessages}
                    setQuickMessages={setQuickMessages}
                    setPopupOpen={setPopupOpen}
                    internalNote={internalNote}
                    onMenuClick={handleOpenMenu}
                    onCameraClick={() => setShowCamera(true)}
                  />
                ) : (
                  <div
                    style={{
                      flex: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-end'
                    }}
                  >
                    <Tooltip title="Cancelar gravação" placement="top">
                      <IconButton
                        onClick={handleCancelAudio}
                        component="span"
                        fontSize="large"
                        aria-label="Cancelar gravação de áudio"
                        className={classes.cancelAudioIcon}
                      >
                        <CircleX size={26} />
                      </IconButton>
                    </Tooltip>
                    <AudioPlayer
                      audioUrl={audioUrl}
                      variant="compact"
                      isMessageRight={true}
                    />
                  </div>
                )}

                <ActionButtons
                  inputMessage={inputMessage}
                  loading={loading}
                  recording={recording}
                  ticketStatus={ticketStatus}
                  disableOption={disableOption}
                  handleSendMessage={handleSendMessage}
                  audioUrl={audioUrl}
                  handleCancelAudio={handleCancelAudio}
                  handleUploadAudio={handleUploadAudio}
                  handleStartRecording={handleStartRecording}
                  handleStopToPreview={handleStopToPreview}
                  onCameraClick={() => setShowCamera(true)}
                />
              </div>
            </div>
          )}
        </Paper>

        <Dialog
          open={showPixSelector}
          onClose={() => setShowPixSelector(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle className={classes.dialogTitle}>
            Escolha a chave Pix
          </DialogTitle>
          <DialogContent dividers>
            {/* Implementação do Grid de Cards Reutilizando a Identidade Visual */}
            <Grid container spacing={2}>
              {companyPixConfigs.map((pixConfig, index) => {
                const pixTypeLabel =
                  pixTypeLabelMap[pixConfig.type] || 'Chave Pix'

                return (
                  <Grid item xs={12} sm={6} key={`pix-config-${index}`}>
                    <Box
                      className={classes.buttonPix}
                      component="button"
                      onClick={() => handleSendSelectedPixKey(pixConfig)}
                    >
                      {/* Ícone de Chave com Background Sutil */}
                      <Box className={classes.boxPixIcon} aria-hidden="true">
                        <Key size={18} />
                      </Box>

                      {/* Textos Informativos e Chave */}
                      <Box flexGrow={1} overflow="hidden">
                        <Typography variant="body1" className={classes.pixName}>
                          {pixConfig.accountName}
                        </Typography>

                        <Typography variant="body2" className={classes.pixKey}>
                          {pixConfig.key}
                        </Typography>

                        <Box className={classes.chipPix}>{pixTypeLabel}</Box>
                      </Box>
                    </Box>
                  </Grid>
                )
              })}
            </Grid>
          </DialogContent>
          <DialogActions>
            <ButtonSecondary
              onClick={() => setShowPixSelector(false)}
              color="secondary"
              label="Cancelar"
            />
          </DialogActions>
        </Dialog>
        {/* )} */}
      </UploadDropZone>
      <ContactPickerModal
        open={showContactPicker}
        onClose={() => setShowContactPicker(false)}
        onSelectContact={handleSendContact}
        disabled={disableOption}
      />
      <CameraModal
        open={showCamera}
        onClose={() => setShowCamera(false)}
        onCapture={handleSendMedia}
        disabled={disableOption}
      />
      <ContactFilesOptionsModal
        open={showContactFilesOptions}
        onClose={() => setShowContactFilesOptions(false)}
      />
      <FilesList
        open={showFilesList}
        onClose={() => setShowFilesList(false)}
        onSelectFile={handleSendFile}
      />

      <TransferTicketModalCustom
        modalOpen={transferTicketModalOpen}
        onClose={handleCloseTransferTicketModal}
        ticketid={ticketId}
      />
    </div>
  )
}

export default withWidth()(MessageInputCustom)
